import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { CircularProgress, ThemeProvider, createTheme } from "@mui/material";

import { HOME, REPORT } from "./utils/path";

import Header from "./components/Header/Header";

const Home = lazy(() => import("./view/Home/Home"));
const Report = lazy(() => import("./view/Report/Report"));
const About = lazy(() => import("./components/About/About"));
const ErrorBadge = lazy(() => import("./components/Error/Error"));

const theme = createTheme({
  palette: {
    primary: {
      main: "#003399",
    },
  },
  typography: {
    fontFamily: ["Barlow", "Arial", "Helvetica", "sans-serif"].join(","),
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Header />

      <About />

      <ErrorBadge />
      <Suspense
        fallback={
          <div className="initial-loader">
            <CircularProgress size="60px" />
          </div>
        }
      >
        <Routes>
          <Route path={HOME} element={<Home />} />
          <Route path={REPORT} element={<Report />} />
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
